/* ============================================================
   ms-line-item-options.js
   line item property（紐の長さ・セルの色）関連の共通ロジック。
   商品ページ（snippets/product-form.liquid）とカートページ
   （sections/cart-template.liquid）のインライン script から使う。

   長さ区分データ（LENGTH_RANGES）はメタオブジェクト
   line_item_length_range を各テンプレートが Liquid で JSON 展開して渡す。
   ============================================================ */
window.MSLineItemOptions = {
  /**
   * 半角数字のみか（空・null は false）
   * @param {*} val
   * @returns {boolean}
   */
  isHalfWidthNumeric: function (val) {
    if (val == null || String(val).trim() === '') return false;
    return /^[0-9]+$/.test(String(val).trim());
  },

  /**
   * 長さ区分文字列から入力可能範囲 {min, max} を決定する。
   * 優先順位: ① メタオブジェクト trigger の部分一致
   *           ② 「数字〜数字」表記の解析（101~150 / 101〜150 等）
   *           ③ 「~数字」表記の解析（~100 等 → 1..上限）
   *           ④ どれも該当しなければ null（呼び出し側で既定 1..100 を適用）
   * @param {string} v      判定対象文字列（バリアントオプション値 or バリアントタイトル）
   * @param {Array<{trigger: string, min: number, max: number}>} ranges
   * @returns {{min: number, max: number}|null}
   */
  decideRangeFromStr: function (v, ranges) {
    if (!v) return null;
    for (var i = 0; i < (ranges || []).length; i++) {
      var r = ranges[i];
      var trig = (r && r.trigger) ? String(r.trigger) : '';
      if (trig && v.indexOf(trig) !== -1) return { min: r.min, max: r.max };
    }
    var both = v.match(/(\d+)\D+(\d+)/);
    if (both) return { min: parseInt(both[1], 10), max: parseInt(both[2], 10) };
    var upper = v.match(/[~〜]\s*(\d+)/);
    if (upper) return { min: 1, max: parseInt(upper[1], 10) };
    return null;
  }
};
